import { render, staticRenderFns } from "./PopupType2.vue?vue&type=template&id=ce916250&"
import script from "./PopupType2.vue?vue&type=script&lang=js&"
export * from "./PopupType2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports